var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { EventsService } from "app/lib/EventsService";
import { BaseComponent } from "app/views/base.component";
import { HelperService } from "../../lib/helper.service";
import { HttpClient } from "@angular/common/http";
import { ChartParams } from "../../views/chart/chart.component";
import { ModalService } from "app/views/modal/base_modal.component";
import { BillingService2 } from "../billing.service";
var UberComponent = /** @class */ (function (_super) {
    __extends(UberComponent, _super);
    function UberComponent(eventsService, activatedRoute, translate, router, modalService, filter, http, helper, service2) {
        var _this = _super.call(this, eventsService, service2, activatedRoute, filter, translate) || this;
        _this.eventsService = eventsService;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.router = router;
        _this.modalService = modalService;
        _this.filter = filter;
        _this.http = http;
        _this.helper = helper;
        _this.service2 = service2;
        _this.chart = new ChartParams();
        _this.stats = [];
        _this.money = {};
        _this.loader = false;
        _this.currentPage = 1;
        _this.totalRec = 0;
        _this.totalPaidRec = 0;
        _this.totalFailRec = 0;
        _this.addFilterParams = {
            isBilling: true,
            dateFilters: ['dateCreated', 'datePaid', 'dateSiteCreated'],
        };
        return _this;
    }
    UberComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getChart()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getTotal()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getStats()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UberComponent.prototype.getChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service2.uber.chart(this.filter.filterParams).toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        this.chart.data = charts;
                        return [2 /*return*/];
                }
            });
        });
    };
    UberComponent.prototype.getTotal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, totalRec, totalPaidRec, totalFailRec, money;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.service2.uber.total(this.filter.filterParams).toPromise()];
                    case 1:
                        _a = _b.sent(), totalRec = _a.totalRec, totalPaidRec = _a.totalPaidRec, totalFailRec = _a.totalFailRec, money = _a.money;
                        this.totalRec = totalRec;
                        this.totalPaidRec = totalPaidRec;
                        this.totalFailRec = totalFailRec;
                        this.money = money;
                        return [2 /*return*/];
                }
            });
        });
    };
    UberComponent.prototype.getStats = function () {
        return __awaiter(this, void 0, void 0, function () {
            var stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loader = true;
                        return [4 /*yield*/, this.service2.uber.stats(__assign({}, this.filter.filterParams, { page: this.currentPage })).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        this.stats = stats;
                        this.loader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    UberComponent.prototype.onPageChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getStats()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return UberComponent;
}(BaseComponent));
export { UberComponent };
